import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import IconDS22, { IconIds } from '../IconDS22';
import getClassNames from '../../utils/getClassNames';
import styles from './ListingBadge.module.scss';

export const variants = [
  'bestOfYear',
  'instabook',
  'motivator-high',
  'motivator-limited',
  'rating',
  'recommended',
  'snoozed',
  'superowner',
] as const;
type Variant = typeof variants[number];

const iconMap: Partial<Record<Variant, IconIds>> = {
  rating: 'star-filled',
  superowner: 'medal',
  bestOfYear: 'trophy',
  instabook: 'instabook-filled',
  snoozed: 'moon-filled',
};

export type ListingBadgeProps = {
  children: ReactNode;
  variant: Variant;
  /** Map card */
  isPopup?: boolean;
  /** Intended for non-ListingCard components, such as BoatOwnerInfo on `/listing/[id]/preview/` */
  previewMode?: boolean;
};

const ListingBadge: FC<ListingBadgeProps> = ({
  children,
  variant,
  isPopup,
  previewMode,
}) => {
  const isMotivator = variant === 'motivator-high' || variant === 'motivator-limited';
  const iconId = iconMap[variant];
  return (
    <div
      className={getClassNames(
        styles,
        'root',
        classNames(variant, { popup: isPopup, previewMode }),
      )}
    >
      <div
        className={getClassNames(styles, 'icon', classNames(variant, { previewMode }))}
      >
        {/* When no icon is provided, we still want to render the div for the motivator dot */}
        {!isMotivator && iconId && (
          <IconDS22
            id={iconId}
            size="s"
          />
        )}
      </div>
      {children}
    </div>
  );
};

export default ListingBadge;
